'use client';

import DEFAULT_OPERATIONS from '@/components/CreateAccount/createAccount.gql';
import { GET_ITEM_COUNT_QUERY } from '@/components/Header/cartTrigger.gql';
import StoreConfig from '@/config';
import { IS_USE_PRODUCTION_ENV } from '@/constants/is-use-production-env';
import { useCartContext } from '@/context/cart';
import { useUserContext } from '@/context/user';
import { BrowserPersistence } from '@/util';
import { useMutation, useQuery } from '@apollo/client';

const storage = new BrowserPersistence();

export const useSwitchCountry = () => {
  const [{ cartId }, { createCart, removeCart }] = useCartContext();

  const { data: itemCountQueryRes } = useQuery(GET_ITEM_COUNT_QUERY, {
    fetchPolicy: 'cache-first',
    errorPolicy: 'all',
    skip: !cartId,
    variables: {
      cartId,
    },
  });

  const itemCount = itemCountQueryRes?.cart?.total_quantity || 0;

  const [{ isSignedIn }] = useUserContext();

  const { createCartMutation } = DEFAULT_OPERATIONS;

  const [fetchCartId] = useMutation(createCartMutation);

  const availableCountries = StoreConfig.available_countries;

  const currentCountryCode = StoreConfig.current_country_code;

  const handleSwitchCountry = async countryCode => {
    const targetCountry = availableCountries.find(temp => temp.code === countryCode);

    const currentCountry = availableCountries.find(temp => temp.code === currentCountryCode);

    const signin_token = storage.getItem('signin_token');
    let url = null;

    if (isSignedIn) {
      // 已登录

      const currentUrl = window.location.href;
      url = new URL(currentUrl);

      // 获取当前的查询参数
      const queryParams = new URLSearchParams(url.search);

      queryParams.set('from_country', currentCountryCode);
      queryParams.set('token', signin_token);

      if (itemCount > 0) {
        // 购物车不为空
        queryParams.set('cart_id', cartId);
        // 清空购物车

        await removeCart();

        await createCart({
          fetchCartId,
        });
      }

      // 更新 URL 的查询参数
      url.search = queryParams.toString();
    } else {
      const currentUrl = window.location.href;
      url = new URL(currentUrl);

      // 获取当前的查询参数
      const queryParams = new URLSearchParams(url.search);

      queryParams.set('from_country', currentCountryCode);

      if (itemCount > 0) {
        // 购物车不为空
        queryParams.set('cart_id', cartId);

        // 清空购物车
        await removeCart();

        await createCart({
          fetchCartId,
        });
      }

      // 更新 URL 的查询参数
      url.search = queryParams.toString();
    }

    let targetUrl = url.toString().replace(currentCountry.urlPart, targetCountry.urlPart);
    const targetUrlInstance = new URL(targetUrl);

    if (IS_USE_PRODUCTION_ENV && targetUrlInstance.hostname.indexOf('www.') === -1) {
      targetUrlInstance.hostname = `www.${targetUrlInstance.hostname}`;
    }

    if (
      currentCountryCode === 'us' &&
      targetCountry.code !== 'us' &&
      [
        `${targetCountry.basePath}/scholarship-program`,
        `${targetCountry.basePath}/2024-scholarship-program`,
        `${targetCountry.basePath}/2025-scholarship-program`,
        `${targetCountry.basePath}/2026-scholarship-program`,
      ].includes(targetUrlInstance.pathname)
    ) {
      targetUrlInstance.pathname = targetCountry.basePath || '/';
    }

    if (currentCountryCode !== 'uk' && targetCountry.code === 'uk') {
      targetUrlInstance.pathname = targetUrlInstance.pathname.replace('/colors-family/', '/colours-family/');

      const queryColorsFamily = targetUrlInstance.searchParams.get('colors-family');

      if (queryColorsFamily) {
        targetUrlInstance.searchParams.set('colours-family', queryColorsFamily);
        targetUrlInstance.searchParams.delete('colors-family');
      }
    }

    if (currentCountryCode === 'uk' && targetCountry.code !== 'uk') {
      targetUrlInstance.pathname = targetUrlInstance.pathname.replace('/colours-family/', '/colors-family/');

      const queryColorsFamily = targetUrlInstance.searchParams.get('colours-family');

      if (queryColorsFamily) {
        targetUrlInstance.searchParams.set('colors-family', queryColorsFamily);
        targetUrlInstance.searchParams.delete('colours-family');
      }
    }

    const paginationRemovedPathname =
      '/' +
      targetUrlInstance.pathname
        .split('/')
        .reduce((acc, cur, i, arr) => {
          if (!cur || cur === 'p' || (i > 0 && arr[i - 1] === 'p' && /^\d+$/.test(cur))) return acc;

          acc.push(cur);

          return acc;
        }, [])
        .join('/');
    targetUrlInstance.pathname = paginationRemovedPathname;
    targetUrlInstance.searchParams.delete('page');

    targetUrl = targetUrlInstance.toString();
    window.location.href = targetUrl;
  };

  return {
    handleSwitchCountry,
  };
};
